export default theme => ({
  root: {
    '&:not(:last-child)': {
      marginRight: theme.spacing(0.5)
    }
  },
  tooltipTable: {
    color: theme.palette.common.white,
    fontSize: 12,
    '& td': {
      padding: 0,
      paddingTop: theme.spacing(0.5),
      verticalAlign: 'top'
    },
    '& td:first-child': {
      fontWeight: 500,
      paddingRight: theme.spacing(1),
      whiteSpace: 'nowrap'
    }
  }
});
